import React, { useState } from "react";
import BetterAlerts from "../BetterAlerts";
import BetterBox from "../BetterBox";
import { Button } from "react-bootstrap";
// Importe InputAdornment e IconButton para os ícones
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import Swal from "sweetalert2";

export default function NewPassword({ errors, submitted, handleSubmit }) {
	const [password, setPassword] = useState('');
	const [repeatPassword, setRepeatPassword] = useState('');
	const [verPassword, setVerPassword] = useState(false);
	const [verRepPassword, setVerRepPassword] = useState(false);

	const beforeSubmit = () => {
		if (!password || !repeatPassword) {
			return Swal.fire("Atenção", "Preencha todos os campos.", "warning");
		}
		if (password !== repeatPassword) {
			return Swal.fire("Ops!", "As senhas não coincidem, tente novamente.", "error");
		}
		handleSubmit(password);
	}

	return (
		<div>
			<div className="col-sm-12">
				<BetterAlerts errors={errors} />
			</div>

			<div className="col-sm-12">
				<BetterBox title="Redefinir Senha" subtitle="Crie uma nova senha segura para sua conta.">

					<div className="form-group fg-line mb-4">
						<TextField
							fullWidth
							type={verPassword ? "text" : "password"}
							label="Nova Senha *"
							variant="outlined"
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton onClick={() => setVerPassword(!verPassword)} edge="end">
											<i className={verPassword ? "fa fa-eye" : "fa fa-eye-slash"}></i>
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</div>

					<div className="form-group fg-line mb-4">
						<TextField
							fullWidth
							type={verRepPassword ? "text" : "password"}
							label="Confirmar Nova Senha *"
							variant="outlined"
							value={repeatPassword}
							onChange={(e) => setRepeatPassword(e.target.value)}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton onClick={() => setVerRepPassword(!verRepPassword)} edge="end">
											<i className={verRepPassword ? "fa fa-eye" : "fa fa-eye-slash"}></i>
										</IconButton>
									</InputAdornment>
								),
							}}
						/>
					</div>
				</BetterBox>
			</div>

			<div className="col-sm-12 mt-4">
				<div className="d-flex justify-content-between">
					<Button style={{ fontWeight: 400 }} disabled={submitted} variant="secondary" onClick={() => { window.location.href = "/auth/login" }}>
						Voltar
					</Button>

					<Button disabled={submitted} variant="primary" onClick={beforeSubmit}>
						<i className={`margin-icon ${submitted ? "fas fa-sync fa-spin" : "fa fa-check-square"}`}></i>
						{submitted ? " Enviando..." : " Alterar Senha"}
					</Button>
				</div>
			</div>
		</div>
	);
}